export const ACTION_SET_TIME = "ACTION_SET_TIME";
export const ACTION_SET_TIME_VALUE = "ACTION_SET_TIME_VALUE";

export const actionSetTime = (payload) => {
  return { type: ACTION_SET_TIME, payload };
};

export const actionSetTimeValue = (payload) => {
  return { type: ACTION_SET_TIME_VALUE, payload };
};